import { CarouselImage } from '@/modules/content-blocks/interfaces';

export const createDefaultImage = (): CarouselImage => ({
   id: crypto.randomUUID(),
   url: '',
   alt: '',
   caption: '',
   image_id: null,
   image: {
      alt_text: null,
      id: null,
      url: null,
      name: null,
   },
});
